export default __webpack_public_path__ + "static/media/165.1ad8e3e9.gif";